import { render, staticRenderFns } from "./r-currency-group-page.vue?vue&type=template&id=1dcdfb66&scoped=true&class=currency-group-page"
import script from "./r-currency-group-page.vue?vue&type=script&lang=js"
export * from "./r-currency-group-page.vue?vue&type=script&lang=js"
import style0 from "./r-currency-group-page.vue?vue&type=style&index=0&id=1dcdfb66&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcdfb66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dcdfb66')) {
      api.createRecord('1dcdfb66', component.options)
    } else {
      api.reload('1dcdfb66', component.options)
    }
    module.hot.accept("./r-currency-group-page.vue?vue&type=template&id=1dcdfb66&scoped=true&class=currency-group-page", function () {
      api.rerender('1dcdfb66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency-group/r-currency-group-page.vue"
export default component.exports